// Hooks
import { useAtom } from 'jotai';

import useSocialProfile from '@/utils/hooks/giveaway-picker/useSocialProfile';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { GetSelectedProfile } from '@/lib/giveawayPicker/GetSelectedProfile';
import { giveawayPickerWebflowUrl } from '@/lib/urls/giveawayPickerUrl';

import Button, { ERROR_SECONDARY } from '@/components/base/Button';
import CompoundBanner from '@/components/base/InfoBanner/CompoundBanner';
// Atoms
import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';
// Components
import { SelectFreeTool } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/SelectFreeTool';

export const SelectAccount = () => {
    const { t } = useTranslation('giveaway_picker');
    const { userSocialProfileData, isLoading, socialProfileError } = useSocialProfile();
    const [selectedProfile, setSelectedProfile] = useAtom(socialProfileAtom);

    if (socialProfileError) {
        const errorMessage =
            socialProfileError?.response?.data?.message ||
            t('account_selection.error_loading_profiles');
        return (
            <CompoundBanner>
                <CompoundBanner.Icon />
                <CompoundBanner.Content message={errorMessage} />
                <Button
                    variant={ERROR_SECONDARY}
                    size="sm"
                    onClick={() => {
                        window.parent.location.href = giveawayPickerWebflowUrl;
                    }}
                    data-testid="reauth-button">
                    {t('reauth')}
                </Button>
            </CompoundBanner>
        );
    }
    if (isLoading) {
        return (
            <div
                className="mb-2 flex items-center gap-3 rounded-md bg-gray-100 p-[35px] text-sm text-gray-500"
                data-testid="loading-state"
            />
        );
    }
    if (!userSocialProfileData) {
        return null;
    }

    return (
        <SelectFreeTool
            socialProfilesList={userSocialProfileData}
            selected={GetSelectedProfile(t, selectedProfile)}
            setSelected={(selectedOption) => {
                setSelectedProfile(selectedOption.profile);
            }}
        />
    );
};
